import React from "react";
import AccountHistoryLayout from "../pages/account-history/AccountHistoryLayout";

const AccountHistory = () => {
    return <AccountHistoryLayout />;
};

export default AccountHistory;
